import { useNavigate, useParams } from "react-router-dom"
import { Grid, Layout, Loader, LoaderContainer, Paper, Input, Table, Typography, Button } from "../../components"
import {useAPI} from '../../hooks'
import {useFormik} from 'formik'
import { useCallback, useEffect, useMemo } from "react"
import { UpdateGroupSchema, UpdateGroupCompanyConfigurationSchema } from "@bussola-viagens/validations"
import { enqueueSnackbar } from "notistack"
import { Box, Tab, Tabs } from "@mui/material"
import { useTabs } from "@mui/base"
import { Programs } from "./Programs"

export const CostsPage = () => {    
    const tabs = useTabs({
        defaultValue: 'PROGRAMS'
    })
    
    return (
        <Layout>
            <Grid container p={2} spacing={1} justifyContent={'center'}>
                <Grid item xs={12}>
                    <Paper>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={tabs.contextValue.value} onChange={tabs.contextValue.onSelected}>
                                <Tab label="Programas" value="PROGRAMS" />
                            </Tabs>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={10}>
                    {
                        tabs.contextValue.value === 'PROGRAMS' ? (
                            <Programs />
                        ) : null
                    }
                </Grid>
            </Grid>
        </Layout>
    )
}